/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Complete_RewardInputs */

const en_check_in_complete_reward = /** @type {(inputs: Check_In_Complete_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

const es_check_in_complete_reward = /** @type {(inputs: Check_In_Complete_RewardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar`)
};

/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Check_In_Complete_RewardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_complete_reward = /** @type {((inputs?: Check_In_Complete_RewardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Complete_RewardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_complete_reward(inputs)
	return es_check_in_complete_reward(inputs)
});